import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Send as SendIcon } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

import useSuggestionPermissions from '../../../hooks/useSuggestionPermissions.js';
import SeparateStatusChip from '../../atoms/SeparateStatusChip/SeparateStatusChip.jsx';

type Props = {
  isEnabledSuggestion: boolean;
  onOpenPublishDialog: () => void;
};

const PublishSuggestion = ({
  isEnabledSuggestion,
  onOpenPublishDialog,
}: Props) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');
  const { isPublishAllowed } = useSuggestionPermissions();

  return (
    isPublishAllowed && (
      <div>
        {isEnabledSuggestion ? (
          <SeparateStatusChip type="Published" />
        ) : (
          <Button variant="outlined" size="small" onClick={onOpenPublishDialog}>
            <SendIcon />
            {t('Publish')}
          </Button>
        )}
      </div>
    )
  );
};

export { PublishSuggestion };
